import { DocDto } from "./doc-dto";

export enum DOC_ACTION { NONE, TRASH, UNTRASH, REMOVE, DELETE }

export class DocActionDto {

    public recentDocDto: DocDto | null = null;
    public recentAction: DOC_ACTION = DOC_ACTION.NONE;

    constructor(recentdocDto: DocDto, recentAction: DOC_ACTION) {
        this.recentDocDto = recentdocDto;
        this.recentAction = recentAction;
    }

}
